// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetHash} from '../asset-hash.js'
import {ASRSegment} from '../search-index/asrsegment.js'

export class RecordingTranscription {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): RecordingTranscription {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsRecordingTranscription(
    bb: flatbuffers.ByteBuffer,
    obj?: RecordingTranscription
  ): RecordingTranscription {
    return (obj || new RecordingTranscription()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsRecordingTranscription(
    bb: flatbuffers.ByteBuffer,
    obj?: RecordingTranscription
  ): RecordingTranscription {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new RecordingTranscription()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  assetHash(obj?: AssetHash): AssetHash | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetHash()).__init(this.bb_pos + offset, this.bb!) : null
  }

  transcriptionLanguage(): string | null
  transcriptionLanguage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  transcriptionLanguage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  segments(index: number, obj?: ASRSegment): ASRSegment | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new ASRSegment()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  segmentsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startRecordingTranscription(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addAssetHash(builder: flatbuffers.Builder, assetHashOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, assetHashOffset, 0)
  }

  static addTranscriptionLanguage(builder: flatbuffers.Builder, transcriptionLanguageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, transcriptionLanguageOffset, 0)
  }

  static addSegments(builder: flatbuffers.Builder, segmentsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, segmentsOffset, 0)
  }

  static createSegmentsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startSegmentsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endRecordingTranscription(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // asset_hash
    builder.requiredField(offset, 8) // segments
    return offset
  }

  static createRecordingTranscription(
    builder: flatbuffers.Builder,
    assetHashOffset: flatbuffers.Offset,
    transcriptionLanguageOffset: flatbuffers.Offset,
    segmentsOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    RecordingTranscription.startRecordingTranscription(builder)
    RecordingTranscription.addAssetHash(builder, assetHashOffset)
    RecordingTranscription.addTranscriptionLanguage(builder, transcriptionLanguageOffset)
    RecordingTranscription.addSegments(builder, segmentsOffset)
    return RecordingTranscription.endRecordingTranscription(builder)
  }
}
